
<template>
  <div id="slide">
    <div class="slider-selection observable">
      <h2 class="slider-selection-top">
        <span class="title-sub"></span>
        <span class="title-1"></span>
      </h2>

      <!-- Tabs -->
      <div class="slider-selection-tab">
        <div class="dropdown dropdown-mobile">
          <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">
            <span class="caret"></span>
            <span class="btn-inner"></span>
          </button>
          <div class="dropdown-menu open">
            <div class="dropdown-menu inner">
              <div class="tab-item slider-selection-tab-item active" data-id="tab1">
                <span></span>
              </div>
              <div class="tab-item slider-selection-tab-item" data-id="tab2">
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="slider-container" id="slider-selection">
        <!-- Slider nav -->
        <div ref="sliderscroll" class="slider-nav">
          <div class="slider-nav-container">
            <div class="slider-nav-buttons">
              <div class="slider-nav-item slider-nav-item-prev"
                id="slider-selection-prev"
                @click="onPaginationPrev">
                <div class="slider-nav-item-icon-container">
                  <span class="slider-nav-item-icon-1">
                    <svg class="icon icon-fleche">
                      <use xlink:href="#fleche"></use>
                    </svg>
                  </span>
                  <span class="slider-nav-item-icon-2">
                    <svg class="icon icon-fleche">
                      <use xlink:href="#fleche"></use>
                    </svg>
                  </span>
                </div>
              </div>
              <div class="slider-nav-item slider-nav-item-next"
                id="slider-selection-next"
                @click="onPaginationNext">
                <div class="slider-nav-item-icon-container">
                  <span class="slider-nav-item-icon-1">
                    <svg class="icon icon-fleche">
                      <use xlink:href="#fleche"></use>
                    </svg>
                  </span>
                  <span class="slider-nav-item-icon-2">
                    <svg class="icon icon-fleche">
                      <use xlink:href="#fleche"></use>
                    </svg>
                  </span>
                </div>
              </div>
            </div>

            <div class="slider-nav-pagination">
              <span class="ff-tt ft-60 slider-nav-page">01</span>
              <span class="ff-tt ft-30 slider-nav-total">01</span>
            </div>
            <!-- Progress bar -->
            <div ref="progress" class="slider-progress slider-nav-progress" id="slider-selection-progress">
              <div ref="progressInner" class="slider-progress-inner"></div>
            </div>

            <div class="know-btn-wrap">
              <Knowbtn1 @btnclick="gotoPage" />
            </div>
          </div>
        </div>

        <div class="slider-selection-slides active"
          ref="domtopslider"
          id="slider-selection-tab1"
          data-id="tab1"
          data-total="9">
          <!-- Slider item -->
          <!-- <div class="productitem"
            v-for="item in items"
            :key="item.ID">
            <ProductItem
              :id="item.ID"
              :img="item.SMALLPIC | imgFilter"
              :title="item.PRONAME"
              :info="item.MS"
              @select-product="gotoProductPage" />
          </div> -->
          <div class="slider-selection-item"
            v-for="item in items"
            :key="item.ID">
            <a
              :href="item | filterHref"
              class="slider-selection-card change-page">
              <div class="slider-selection-card-img img-lazyload-container">
                <!-- <img
                  class="img-lazyload"
                  data-lazyload="true"
                  src="/images/randonnee-a-landmannalaugar-1271.png"
                  alt="Landmannalaugar"
                  title="Randonn"
                > -->
                <img class="img-lazyload"
                  data-lazyload="true"
                  :src="item.SMALLPIC | imgFilter">
              </div>
              <div class="slider-selection-card-content">
                <!-- <h4 class="slider-selection-card-title">金枪鱼罐头</h4> -->
                <h4 class="slider-selection-card-title">{{ item.PRONAME }}</h4>
                <!-- <p class="slider-selection-card-desc">Terres insolites du Nord au Sud</p> -->
                <!-- <div class="slider-selection-card-infos">
                </div> -->
                <div class="slider-selection-card-price">
                  {{ item.MS }}
                </div>
              </div>
              <div class="slider-selection-card-button">
                <span>{{$t('btn1')}}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Knowbtn1 from '@/components/Knowbtn1.vue'
import Slider from '@/n66/slider.js'
import {
  qs, qsa, domAddClass, domRemoveClass
} from '@/util/dom.js'
import { TimelineLite, TweenLite, Expo, Power3 } from 'gsap/TweenMax'
import scroll from '@/oceanSchool/scroll.js'
import { getCommendProductsUrl } from '@/util/url.js'
import axios from 'axios'

export default {
  components: {
    Knowbtn1
  },

  data () {
    return {
      items: []
    }
  },

  beforeDestroy () {
    scroll.unbind('show-slide')

    this.tlMoveSelectionSlide && this.tlMoveSelectionSlide.kill()
    this.tlMoveSelectionSlide = null
    this.tlMoveSelectionSlide1 && this.tlMoveSelectionSlide1.kill()
    this.tlMoveSelectionSlide1 = null
  },

  mounted () {
    this.dom = {}
    this.page = 0
    this.sens = 0
    this.total = 3
    this.canSlide = true
    this.hasSwipe = true

    this.viewww = document.body.offsetWidth
    this.viewwh = document.body.offsetHeight
    this.isShowFirstSlider = false
    this.isDouble = false
    this.isInit = false

    this.fechData()

    // this.init()
  },

  methods: {
    fechData () {
      const url = getCommendProductsUrl(this.$store.state.lang)
      axios.get(url).then(res => {
        // console.log(res)
        if (res && res.data && res.data.proarr && res.data.proarr.length > 0) {
          this.items = res.data.proarr

          this.$refs.domtopslider.setAttribute('data-total', this.items.length)

          this.$nextTick(() => {
            this.init()
          })
        }
      })
    },

    init () {
      this.initProgress()

      this.initDOM()
      if (this.slidesTab1.length > 0) {
        this.sliderSelection = new Slider('slider-selection',
          this.onSliderSelectionChange, true, true)
        this.setNbMove()
        this.initObjsSliders()
        // this.currentSlider = this.dataSliderTab1
        this.setPosSelectionSlider()
        this.updateNavTotal(false)
        this.checkStateSliderNav()

        TweenLite.set(this.slidesTab1, {
          x: '+=' + (this.widthSlide + this.viewww / 1.5),
          opacity: 0
        })
        this.isInit = true
      }

      scroll.bind('show-slide', this.scrollShowSlide)
    },

    initDOM () {
      // this.slider = qs('.slider-selection', this.$el)
      // this.sliderContainer = qs('.slider-container', this.slider)
      this.sliderSlidesContainer = qs('.slider-selection-slides', this.$el)
      this.sliderTab1 = qs('#slider-selection-tab1', this.$el)
      this.slidesTab1 = qsa('.slider-selection-item', this.$el)
      this.sliderNavTotal = qs('.slider-nav-total', this.$el)
      this.sliderNav = qsa('.slider-nav', this.$el)
      this.sliderNavPage = qs('.slider-nav-page', this.$el)
      // this.$sliderNavProgress = this.$sliderNav.find(".slider-nav-progress")
      // this.$sliderNavProgressBar = this.$sliderNavProgress.find(".slider-nav-progress-bar")
    },

    setNbMove () {
      this.nbMove = 3

      if (this.viewww < 1020) {
        this.nbMove = 1
      } else if (this.viewww < 1440) {
        this.nbMove = 2
      }
    },

    initObjsSliders () {
      this.dataSliderTab1 = {
        id: this.sliderTab1.dataset.id,
        el: this.sliderTab1,
        width: this.widthSliderTab1,
        total: parseInt(this.sliderTab1.dataset.total),
        page: 0
      }
    },

    setPosSelectionSlider () {
      const t = this.slidesTab1[0]
      this.widthSlide = t.offsetWidth
      this.widthSliderTab1 = this.widthSlide * parseInt(this.sliderTab1.dataset.total)

      for (let e = 0; e < this.slidesTab1.length; e++) {
        TweenLite.set(this.slidesTab1[e], {
          x: e * this.widthSlide
        })
      }
    },

    updateNavPage (t) {
      var e = Math.ceil(this.dataSliderTab1.page + 1)
      e < 10 && (e = '0' + e)
      t ? TweenLite.to(this.sliderNavPage, 0.8, {
        y: 80,
        ease: Expo.easeIn,
        onComplete: function () {
          this.sliderNavPage.innerHTML = e
          TweenLite.set(this.sliderNavPage, {
            y: -80,
            ease: Expo.easeOut
          })
          TweenLite.to(this.sliderNavPage, 0.8, {
            y: 0,
            ease: Expo.easeOut
          })
        }.bind(this)
      }, 0) : TweenLite.to(this.sliderNavPage, 0.8, {
        y: 80,
        ease: Expo.easeIn,
        onComplete: function () {
          this.sliderNavPage.innerHTML = e
          TweenLite.set(this.sliderNavPage, {
            y: 80,
            ease: Expo.easeOut
          })
          TweenLite.to(this.sliderNavPage, 0.8, {
            y: 0,
            delay: 0.15,
            ease: Expo.easeOut
          })
        }.bind(this)
      }, 0)
    },

    updateNavTotal (t) {
      var e = this.total
      if (e < 10) e = '0' + e
      if (t) {
        TweenLite.to(this.sliderNavTotal, 0.8, {
          y: 80,
          delay: 0.3,
          ease: Expo.easeIn,
          onComplete: function () {
            this.sliderNavTotal.innerHTML = e
            TweenLite.set(this.sliderNavTotal, {
              y: 80,
              ease: Expo.easeOut
            })
            TweenLite.to(this.sliderNavTotal, 0.8, {
              y: 0,
              delay: 0,
              ease: Expo.easeOut
            })
          }.bind(this)
        })
      } else {
        this.sliderNavTotal.innerHTML = e
      }
    },

    checkStateSliderNav () {
      if (this.sliderSlidesContainer.dataset.total <= this.nbMove) {
        this.disableSliderNav()
      } else {
        this.enableSliderNav()
      }
    },

    disableSliderNav () {
      domAddClass(this.sliderNav[0], 'disable')
    },

    enableSliderNav () {
      domRemoveClass(this.sliderNav[0], 'disable')
    },

    onSliderSelectionChange (t, e) {
      var i = this
      var s = this.sliderSelection
      var n = this.dataSliderTab1
      // s.isDouble && domAddClass(s.$sliderTabContainer[0], 'no-event'),
      n.page = t
      this.page = t
      i.canSlide = false

      var r
      var o
      var a
      var l
      var h
      var c
      var u = qsa('.slider-selection-item', this.$el)
      var d = this.widthSlide
      // s.currentSlider.width;
      this.tlMoveSelectionSlide = new TimelineLite({
        onComplete: function () {
          i.canSlide = true
        }
      })
      if (e === 1) {
        let tabSelected = []
        for (var p = 0; p < this.nbMove; p++) {
          var f = u[p]
          tabSelected.push(f)
          h = f.cloneNode(true)
          c = d * (u.length + this.nbMove - (this.nbMove - p))
          TweenLite.set(h, {
            x: c,
            opacity: 0
          })
          n.el.append(h)
        }
        u = qsa('.slider-selection-item', this.$el)
        o = []
        for (var m = this.nbMove; m < u.length; m++) {
          r = u[m]
          o.push(r)
        }
        a = []
        l = []
        for (var g = 0; g < o.length; g++) {
          this.elementInViewport(o[g], -d * this.nbMove) ? a.push(o[g]) : l.push(o[g])
        }
        this.tlMoveSelectionSlide.staggerTo(tabSelected, 1.2, {
          opacity: 0,
          x: '-=' + this.viewww / 3 * this.nbMove,
          ease: Expo.easeInOut
        }, 0.08, 0, function () {
          for (var t = 0; t < this.nbMove; t++) {
            tabSelected[t].remove()
          }
        }.bind(this, s)).staggerTo(a, 1.2, {
          x: '-=' + d * this.nbMove,
          opacity: 1,
          ease: Expo.easeInOut
        }, 0.08, 0.08 * this.nbMove).set(l, {
          x: '-=' + d * this.nbMove,
          opacity: 1
        }, 0.04 * this.nbMove)
      } else {
        let tabSelected = []
        for (var v = [], y = u.length - 1; y > u.length - 1 - this.nbMove; y--) {
          r = u[y]
          tabSelected.push(r)
          h = r.cloneNode(true)
          c = -d * (u.length - y)
          c -= this.viewww / 3
          TweenLite.set(h, {
            x: c,
            opacity: 0
          })
          n.el.prepend(h)
          v.push(h)
        }
        u = qsa('.slider-selection-item', this.$el)
        o = []
        for (var _ = this.nbMove; _ < u.length - 2; _++) {
          r = u[_]
          o.push(r)
        }
        a = []
        l = []
        for (var b = 0; b < o.length; b++) {
          this.elementInViewport(o[b], 0) ? a.push(o[b]) : l.push(o[b])
        }
        this.tlMoveSelectionSlide.staggerTo(tabSelected, 1.2, {
          opacity: 0,
          x: '+=' + d * this.nbMove,
          ease: Expo.easeInOut
        }, 0.08, 0, function () {
          for (var t = 0; t < this.nbMove; t++) {
            tabSelected[t].remove()
          }
        }.bind(this, s)).staggerTo(a, 1, {
          x: '+=' + d * this.nbMove,
          opacity: 1,
          ease: Expo.easeInOut
        }, -0.08, 0.08 * this.nbMove).set(l, {
          x: '+=' + d * this.nbMove,
          opacity: 1
        }, 0.08 * this.nbMove).staggerTo(v, 1, {
          x: '+=' + (d * this.nbMove + this.viewww / 3),
          opacity: 1,
          ease: Power3.easeInOut
        }, 0.08, 0.08 * a.length + 0.08 * this.nbMove)
      }
      this.updateNavPage(true)
    },

    limit (t) {
      return t = (t = t >= this.total ? 0 : t) < 0 ? this.total - 1 : t // eslint-disable-line no-return-assign
    },

    initProgress () {
      this.widthProgress = this.$refs.progress.offsetWidth
      this.widthProgressInner = this.widthProgress / this.total
      // this.$nextTick(() => {
      this.$refs.progressInner.style.width = this.widthProgressInner + 'px'
      // })
    },

    onProgress () {
      var t = this.widthProgressInner * Math.ceil(this.page + 1)
      var e = new TimelineLite()
      this.page <= 0 && this.sens === 1 ? e.to(this.$refs.progressInner, 1, {
        width: 0,
        x: this.widthProgress,
        ease: Power3.easeInOut
      }).set(this.$refs.progressInner, {
        x: 0
      }, 1).to(this.$refs.progressInner, 1, {
        width: t,
        ease: Power3.easeInOut
      }, 1) : this.page + 1 >= this.total && this.sens === -1 ? e.to(this.$refs.progressInner, 1, {
        width: 0,
        ease: Power3.easeInOut
      }).set(this.$refs.progressInner, {
        x: this.widthProgress
      }, 1).to(this.$refs.progressInner, 1, {
        width: t,
        x: 0,
        ease: Power3.easeInOut
      }, 1) : TweenLite.to(this.$refs.progressInner, 1, {
        width: t,
        ease: Power3.easeInOut
      }, 0)
    },

    set () {
      if (this.canSlide) {
        this.canSlide = !1
        var t = this.page + this.sens;
        (t = this.limit(t)) !== this.page && (this.page = t, // eslint-disable-line no-unused-expressions
        this.dom.label && (this.dom.label.innerHTML = this.page + 1 + this.prefix + this.total),
        this.onSliderSelectionChange(this.page, this.sens),
        this.onProgress())
      }
    },

    onPaginationNext () {
      this.sens = 1
      this.set()
    },

    onPaginationPrev () {
      this.sens = -1
      this.set()
    },

    elementInViewport (t, e) {
      var s = t.getBoundingClientRect()
      var n = s.top
      var r = s.left + e
      var o = t.offsetWidth
      var a = t.offsetHeight
      return n < window.pageYOffset + this.viewwh && r < window.pageXOffset + this.viewww && n + a > window.pageYOffset && r + o > window.pageXOffset
    },

    showFirstSlide () {
      this.isShowFirstSlider = true
      this.tlMoveSelectionSlide1 = new TimelineLite()
      for (var e = [], i = [], s = 0; s < this.slidesTab1.length; s++) {
        this.elementInViewport(this.slidesTab1[s], -(this.widthSlide + this.viewww / 1.5)) ? e.push(this.slidesTab1[s]) : i.push(this.slidesTab1[s])
      }
      this.tlMoveSelectionSlide1.staggerTo(this.slidesTab1, 1, {
        x: '-=' + (this.widthSlide + this.viewww / 1.5),
        opacity: 1,
        ease: Expo.easeOut
      }, 0.1, 0.5)
    },

    scrollShowSlide () {
      if (!this.$refs.sliderscroll) return

      const { top } = this.$refs.sliderscroll.getBoundingClientRect()
      if (top < window.innerHeight) {
        scroll.unbind('show-slide')
        this.showFirstSlide()
      }
    },
    gotoPage () {
      let routeUrl = this.$router.resolve('/productgroups')
      window.open(routeUrl.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.know-btn-wrap {
  position: relative;
  margin-top: 40px;
}

#slide {
  background-color: #a0c5e1;
}

.slider-selection-top {
  height: 60px;
}

.slider-progress {
    margin: 0 auto;
    width: 80px;
    height: 2px;
    background-color: rgba(255,255,255,.2);
    position: relative
}

.slider-progress-inner {
    width: 20px;
    height: 2px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #96daf0
}

.slider-selection {
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
}

.slider-selection-tab {
  text-align: center;
  font-size: 0;
}

.slider-selection-tab.no-event .tab-item {
  pointer-events: none;
}

.slider-container {
  position: relative;
  height: 570px;
  margin-top: 10px;
}

.slider-selection-slides {
  left: 20%;
  top: 50%;
  margin-top: -205px;
  position: absolute;
  // white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}

.slider-selection-slides.active {
  pointer-events: auto;
  opacity: 1;
  visibility: visible;
}

.slider-selection-item {
  display: inline-block;
  width: 395px;
  padding: 0 38px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  position: absolute;
  left: 0;
  z-index: 1020;
}

.slider-selection-card {
  text-decoration: none;
  min-height: 405px;
  font-size: 14px;
  color: #242a3a;
  width: 100%;
  display: block;
  position: relative;
  background-color: #fff;
  overflow: hidden;
  background-color: #242a3a;
  -webkit-box-shadow: -1px 4px 74px -16px rgba(0, 0, 0, 0.15);
  box-shadow: -1px 4px 74px -16px rgba(0, 0, 0, 0.15);
}

.slider-selection-card-img {
  width: 100%;
  height: 179px;
  overflow: hidden;
  position: relative;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.slider-selection-card-img img {
  width: 100%;
  opacity: 1;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: opacity 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.slider-selection-card-content {
  height: 177px;
  background-color: #fff;
  padding: 24px 30px 24px 30px;
  white-space: auto;
}

.slider-selection-card-title {
  font-size: 24px;
  line-height: 26px;
}

.slider-selection-card-desc {
  margin-bottom: 10px;
  color: #80c7de;
}

.slider-selection-card-infos {
  line-height: 20px;
}

.slider-selection-card-infos-item {
  display: inline-block;
  width: 110px;
}

.slider-selection-card-infos .icon {
  width: 14px;
  height: 14px;
  fill: #242a3a;
  vertical-align: middle;
  display: inline-block;
  margin-right: 10px;
}

.slider-selection-card-price {
  border-top: 1px solid #eaeaea;
  padding-top: 18px;
  margin-top: 18px;
}

.slider-selection-card-price strong {
  color: #96daf0;
  display: block;
  font-size: 36px;
  margin-top: 12px;
}

.slider-selection-card-nbtravels {
  border-top: 1px solid #eaeaea;
  padding-top: 8px;
  margin-top: 18px;
}

.slider-selection-card-nbtravels strong {
  color: #96daf0;
  display: block;
  font-size: 20px;
  margin-top: 12px;
}

.slider-selection-card-button {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 30px;
  background-color: #242a3a;
  color: #fff;
  z-index: 1050;
  overflow: hidden;
  -webkit-transform: translateY(20px);
  transform: translateY(20px);
  -webkit-transition: background 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: background 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1),
    background 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) 0s;
  transition: transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1),
    background 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.slider-selection-card-button span {
  display: block;
  position: absolute;
  text-align: center;
  font-size: 12px;
  left: 0;
  width: 100%;
  -webkit-transform: translateY(80px);
  transform: translateY(80px);
  -webkit-transition: -webkit-transform 0.5s cubic-bezier(0.77, 0, 0.175, 1) 0s;
  transition: -webkit-transform 0.5s cubic-bezier(0.77, 0, 0.175, 1) 0s;
  transition: transform 0.5s cubic-bezier(0.77, 0, 0.175, 1) 0s;
  transition: transform 0.5s cubic-bezier(0.77, 0, 0.175, 1) 0s,
    -webkit-transform 0.5s cubic-bezier(0.77, 0, 0.175, 1) 0s;
}

.slider-selection-card:hover .slider-selection-card-button {
  background-color: #96daf0;
  -webkit-transform: translateY(0);
  transform: translateY(0);
  -webkit-transition: background 0.7s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: background 0.7s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: transform 0.7s cubic-bezier(0.165, 0.84, 0.44, 1),
    background 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: transform 0.7s cubic-bezier(0.165, 0.84, 0.44, 1),
    background 0.7s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.slider-selection-card:hover .slider-selection-card-button span {
  -webkit-transform: translateY(6px);
  transform: translateY(6px);
  -webkit-transition: -webkit-transform 0.7s cubic-bezier(0.77, 0, 0.175, 1) 0s;
  transition: -webkit-transform 0.7s cubic-bezier(0.77, 0, 0.175, 1) 0s;
  transition: transform 0.7s cubic-bezier(0.77, 0, 0.175, 1) 0s;
  transition: transform 0.7s cubic-bezier(0.77, 0, 0.175, 1) 0s,
    -webkit-transform 0.7s cubic-bezier(0.77, 0, 0.175, 1) 0s;
}

.slider-selection-card:hover .slider-selection-card-img img {
  -webkit-transform: scale(1.15);
  transform: scale(1.15);
}

.animate .slider-selection .title-1,
.animate .slider-selection .title-sub {
  opacity: 0;
  -webkit-transform: translateY(100px);
  transform: translateY(100px);
}

.animate .slider-selection .slider-selection-tab {
  opacity: 0;
  -webkit-transform: translateY(100px);
  transform: translateY(100px);
}

.animate .slider-selection.visible .slider-selection-tab,
.animate .slider-selection.visible .title-1,
.animate .slider-selection.visible .title-sub {
  opacity: 1;
  -webkit-transform: translateY(0);
  transform: translateY(0);
  -webkit-transition: opacity 0.6s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s,
    -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 0.6s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s,
    -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 0.6s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s,
    transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 0.6s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s,
    transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.animate .slider-selection.visible .title-1 {
  -webkit-transition-delay: 0.2s;
  transition-delay: 0.2s;
}

.animate .slider-selection.visible .slider-selection-tab {
  -webkit-transition-delay: 0.35s;
  transition-delay: 0.35s;
}

@media (max-width: 1200px) {
  .slider-selection-slides {
    left: 25%;
  }
}

@media (max-width: 1020px) {
  .slider-selection-slides {
    left: 30%;
  }

  .slider-selection-card-button {
    background-color: #96daf0;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }

  .slider-selection-card-button span {
    -webkit-transform: translateY(6px);
    transform: translateY(6px);
  }

  .slider-selection-tab {
    margin-top: 30px;
    margin-bottom: 20px;
  }
}

@media (max-width: 960px) {
  .slider-selection-card-img img {
    height: 100%;
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%) !important;
    transform: translateX(-50%) !important;
  }

  .slider-container {
    height: 470px;
  }

  .slider-selection .slider-nav-buttons {
    display: block;
    position: absolute;
    left: 80px;
    top: -70px;
  }
}

@media (max-width: 760px) {
  .slider-selection .slider-nav-buttons {
    display: none;
  }
}

@media (max-width: 520px) {
  .slider-selection-card {
    max-width: 280px;
    margin: 0 auto;
  }

  .slider-selection-card-content {
    padding-left: 20px;
    padding-right: 20px;
  }
}

.slider-nav {
  left: 0;
  top: 0;
  width: 400px;
  height: 100%;
  position: relative;
  text-align: center;
}

.slider-nav.disable .slider-nav-item {
  opacity: 0.4;
  pointer-events: none;
}

.slider-nav:before {
  content: "";
  display: block;
  background-color: #242a3a;
  position: absolute;
  width: 100vw;
  right: 0;
  height: 100%;
}

.slider-nav-container {
  max-width: 160px;
  padding-left: 80px;
  height: 100%;
  box-sizing: content-box;
}

.slider-nav-buttons {
  position: relative;
  padding-top: 145px;
}

.slider-nav-item {
  display: block;
  margin: 0 auto;
  width: 60px;
  height: 60px;
  position: relative;
  margin-bottom: 16px;
  -webkit-transition: opacity 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;
}

.slider-nav-item:after,
.slider-nav-item:before {
  content: "";
  display: block;
  border: 4px solid #2e3448;
  border-radius: 100%;
  position: absolute;
  width: 52px;
  height: 52px;
  left: 0;
  top: 0;
}

.slider-nav-item:before {
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 80ms,
    -webkit-transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 80ms;
  transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 80ms,
    -webkit-transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 80ms;
  transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 80ms,
    transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 80ms;
  transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 80ms,
    transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 80ms,
    -webkit-transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 80ms;
}

.slider-nav-item:after {
  border-color: #96daf0;
  opacity: 0;
  -webkit-transform: scale(1.3);
  transform: scale(1.3);
  -webkit-transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    -webkit-transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.slider-nav-item-icon-container {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 52px;
  height: 52px;
  border-radius: 100%;
  overflow: hidden;
}

.slider-nav-item .icon {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -8px;
  margin-left: -8px;
  width: 16px;
  height: 16px;
  fill: #fff;
  -webkit-transition: -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.slider-nav-item-icon-1,
.slider-nav-item-icon-2 {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 1;
  -webkit-transition: opacity 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0s cubic-bezier(0.77, 0, 0.175, 1) 0s;
  transition: opacity 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0s cubic-bezier(0.77, 0, 0.175, 1) 0s;
  transition: transform 0s cubic-bezier(0.77, 0, 0.175, 1) 0s,
    opacity 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s;
  transition: transform 0s cubic-bezier(0.77, 0, 0.175, 1) 0s,
    opacity 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0s cubic-bezier(0.77, 0, 0.175, 1) 0s;
}

.slider-nav-item-icon-2 {
  opacity: 0;
  -webkit-transform: translateX(-80px);
  transform: translateX(-80px);
  -webkit-transition: opacity 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s;
  transition: opacity 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s;
  transition: transform 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    opacity 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s;
  transition: transform 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    opacity 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s;
}

.slider-nav-item-prev .icon {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}

.slider-nav-item-prev .slider-nav-item-icon-2 {
  -webkit-transform: translateX(80px);
  transform: translateX(80px);
}

.slider-nav-item:hover:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 50ms,
    -webkit-transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 50ms;
  transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 50ms,
    -webkit-transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 50ms;
  transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 50ms,
    transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 50ms;
  transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 50ms,
    transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 50ms,
    -webkit-transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 50ms;
}

.slider-nav-item:hover:before {
  opacity: 0;
  -webkit-transform: scale(0.7);
  transform: scale(0.7);
  -webkit-transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    -webkit-transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.slider-nav-item:hover .slider-nav-item-icon-1 {
  opacity: 0;
  -webkit-transform: translateX(80px);
  transform: translateX(80px);
  -webkit-transition: opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    -webkit-transform 0.6s cubic-bezier(0.77, 0, 0.175, 1);
  transition: opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    -webkit-transform 0.6s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    -webkit-transform 0.6s cubic-bezier(0.77, 0, 0.175, 1);
}

.slider-nav-item:hover .slider-nav-item-icon-2 {
  opacity: 1;
  -webkit-transform: translateX(0);
  transform: translateX(0);
  -webkit-transition: opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    -webkit-transform 0.6s cubic-bezier(0.77, 0, 0.175, 1);
  transition: opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    -webkit-transform 0.6s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    -webkit-transform 0.6s cubic-bezier(0.77, 0, 0.175, 1);
}

.slider-nav-item-prev:hover .slider-nav-item-icon-1 {
  -webkit-transform: translateX(-80px);
  transform: translateX(-80px);
}

.slider-nav-pagination {
  display: block;
  color: #fff;
  position: relative;
  margin-top: 60px;
  overflow: hidden;
  height: 50px;
  padding-top: 16px;
  padding-bottom: 16px;
  box-sizing: content-box;
}

.slider-nav-page {
  // font-size: 60px;
  color: #fff;
  width: 85px;
  line-height: 50px;
  display: inline-block;
  text-align: center;
  margin-left: -42px;
}

.slider-nav-total {
  // font-size: 30px;
  color: #2e3448;
  display: inline-block;
}

.slider-nav-progress {
  width: 160px;
  height: 2px;
  background-color: #2e3448;
  position: relative;
  margin-top: 0;
}

.slider-nav-progress-bar {
  background-color: #96daf0;
  height: 2px;
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  -webkit-transition: width 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: width 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.slider-nav-progress-bar.complete-right {
  right: 0;
  left: auto;
  -webkit-transition: width 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: width 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.slider-nav-progress-bar.complete-left {
  left: 0;
  -webkit-transition: width 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: width 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
}

@media (max-width: 960px) {
  .slider-nav {
    width: 100%;
    height: 290px;
    position: relative;
    top: 180px;
  }

  .slider-nav-buttons,
  .slider-nav-pagination {
    display: none;
  }

  .slider-nav-container {
    max-width: 100%;
    width: 100%;
    padding: 0;
  }

  .slider-nav-progress {
    position: absolute;
    bottom: 30px;
    left: 50%;
    margin-left: -40px;
    width: 80px;
  }

  .slider-selection-slides {
    top: 0;
    margin-top: 0;
    left: 50%;
    margin-left: -202px;
  }
}
@media(max-width: 768px){
  .slider-container{
    height: auto;
    padding: 20px 0;
  }
  .slider-nav{
    position: static;
    height: auto;
  }
  .slider-selection-slides{
    position: static;
    min-height: 405px;
  }
  .slider-nav-container{
    box-sizing: border-box;
    padding: 20px;
  }
  .slider-selection .slider-nav-buttons{
    position: static;
    display: flex;
    justify-content: center;
    padding-top: 0;
  }
  .btn-know{
    margin: 0 auto;
  }
  .slider-selection-item{
    width: 100%;
  }
}
</style>
